import { render, staticRenderFns } from "./ProjectStep4.vue?vue&type=template&id=4d0742c0&scoped=true"
import script from "./ProjectStep4.vue?vue&type=script&lang=js"
export * from "./ProjectStep4.vue?vue&type=script&lang=js"
import style0 from "./ProjectStep4.vue?vue&type=style&index=0&id=4d0742c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0742c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VIcon,VSelect,VTextField,VTextarea})
